"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.byKeyCache = exports.byKeyWithDefaultFactory = exports.byKey = exports.KeyCacheImpl = exports.toListDataLoader = void 0;
const immutable_1 = require("immutable");
const lens_1 = require("@rixio/lens");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const impl_1 = require("./impl");
const key_batch_1 = require("./key-batch");
const domain_1 = require("./domain");
function toListDataLoader(loader) {
    return ids => Promise.all(ids.map(id => loader(id).then(v => [id, v])));
}
exports.toListDataLoader = toListDataLoader;
const UNDEFINED = Symbol.for("UNDEFINED");
class KeyCacheImpl {
    constructor(map, loader, timeout = 50) {
        this.map = map;
        this.loader = loader;
        this.results = new rxjs_1.Subject();
        this.lensFactory = byKeyWithDefaultFactory(domain_1.idleCache);
        this.singles = new lens_1.SimpleCache(key => new impl_1.CacheImpl(this.getAtom(key), () => this.load(key)));
        this._events = new rxjs_1.Subject();
        this.events = this._events.pipe();
        this.onBatchLoad = this.onBatchLoad.bind(this);
        this.batchHelper = new key_batch_1.BatchHelper(this.onBatchLoad, timeout);
    }
    onBatchLoad(keys) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const values = yield this.loader(keys);
                const map = immutable_1.Map(values);
                keys.forEach(key => {
                    if (map.has(key)) {
                        this.results.next([key, map.get(key)]);
                    }
                    else {
                        this.results.next([key, UNDEFINED]);
                    }
                });
            }
            catch (e) {
                keys.forEach(key => {
                    this.results.next([key, UNDEFINED]);
                });
            }
        });
    }
    single(key) {
        return this.singles.getOrCreate(key, () => this.onCreate(key));
    }
    get(key, force) {
        return this.single(key).get(force);
    }
    set(key, value) {
        this.map.modify(x => x.set(key, domain_1.createFulfilledCache(value)));
        this.onCreate(key);
    }
    onCreate(key) {
        this._events.next({ type: "add", key });
    }
    getAtom(key) {
        return this.map.lens(this.lensFactory(key));
    }
    load(key) {
        return __awaiter(this, void 0, void 0, function* () {
            this.batchHelper.add(key);
            const [, v] = yield this.results
                .pipe(operators_1.filter(([k]) => key === k), operators_1.first())
                .toPromise();
            if (v !== UNDEFINED) {
                return v;
            }
            throw new Error("Not found");
        });
    }
}
exports.KeyCacheImpl = KeyCacheImpl;
function byKey(key) {
    return exports.byKeyCache.getOrCreate(key);
}
exports.byKey = byKey;
function byKeyWithDefaultFactory(defaultValue) {
    const cache = new lens_1.SimpleCache((key) => lens_1.Lens.create((map) => map.get(key) || defaultValue, (v, map) => map.set(key, v)));
    return key => cache.getOrCreate(key);
}
exports.byKeyWithDefaultFactory = byKeyWithDefaultFactory;
exports.byKeyCache = new lens_1.SimpleCache((key) => lens_1.Prism.create((map) => map.get(key), (v, map) => map.set(key, v)));
